export const DEFAULT_ZONES = [
  { id: "front", label: "Front yard" },
  { id: "back", label: "Back yard" },
  { id: "side", label: "Side yard" },
];
